import React, { useState } from 'react';
import { useNavigate } from "react-router-dom";
import { useDispatch } from "react-redux";
import { setUser } from "../../redux/User";
import Cookies from 'js-cookie';

const Register = () => {
    const [email, setEmail] = useState('');
    const [name, setName] = useState('');
    const navigate = useNavigate();
    const dispatch = useDispatch();

    const handleRegister = async () => {
        const password = Math.random().toString(36).slice(-8); // Generate a random password
        const response = await fetch(process.env.REACT_APP_API_URL + '/app/register', {
            method: 'POST',
            headers: {
                'Content-Type': 'application/json',
            },
            body: JSON.stringify({ email, password, name, customer_id: localStorage.getItem('customer_id') }),
        });
        const data = await response.json();

        if (data.ResultCode === '0') {
            Cookies.set('api_token', data.api_token, { expires: 7 });
            localStorage.setItem('customer_id', data.customer_id);
            dispatch(setUser(data.user));
            navigate("/user");
        }
    };

    return (
        <div className="flex justify-center h-screen mt-6">
            <div className="w-full max-w-md p-6">
                <h2 className="text-2xl font-bold mb-6 text-center">Register</h2>
                <div className="mb-4">
                    <label className="block text-gray-700 font-bold p-2">Name</label>
                    <input
                        type="text"
                        value={name}
                        onChange={(e) => setName(e.target.value)}
                        required={true}
                        placeholder="Name"
                        className="w-full px-4 py-2 border rounded-lg focus:outline-none focus:ring-2 focus:ring-blue-600"
                    />
                </div>
                <div className="mb-4">
                    <label className="block text-gray-700 p-2 font-bold">Email</label>
                    <input
                        type="email"
                        value={email}
                        required={true}
                        onChange={(e) => setEmail(e.target.value)}
                        placeholder="Email"
                        className="w-full px-4 py-2 border rounded-lg focus:outline-none focus:ring-2 focus:ring-blue-600"
                    />
                </div>
                <button
                    onClick={handleRegister}
                    className="w-full bg-second-bg text-white py-2 rounded-lg hover:bg-blue-700 transition duration-200"
                >
                    Register
                </button>
            </div>
        </div>
    );
};

export default Register;
